import React from "react";
import { Link, NavLink } from "react-router-dom";
export const Topbar = () => {
  return (
    <div className="footer " style={{ textAlign: "center" }}>
      <>
        <span className="text-muted">
          &copy; {new Date().getFullYear()} ||{" "}
        </span>
        <NavLink className="mr-2 text-muted" to="/disclaimer">
          Disclaimer
        </NavLink>{" "}
        <NavLink className="mr-2 text-muted" to="/terms&conditions">
          Terms&Conditions
        </NavLink>{" "}
        <NavLink className="mr-2 text-muted" to="/privacypolicy">
          Privacy Policy
        </NavLink>
      </>
    </div>
  );
};
